import { css, cx } from '@emotion/css';
import { Translate } from 'react-translate.ts';

import styles from './NoData.module.scss';
import { ReactNode } from 'react';
import { useTheme } from '@tcc-online/react-theme-provider';

type NoDataProps = {
    classNames?: { text?: string; content?: string };
    title?: string;
    children?: ReactNode;
};

export default function NoData(props: NoDataProps) {
    const { classNames = {}, children, title } = props;
    const [theme] = useTheme();

    return (
        <div className={cx(styles.text, classNames?.text)}>
            {title ?? <Translate textOnly>fe.common.list.empty</Translate>}
            <div
                className={cx(
                    styles.content,
                    classNames?.content,
                    css({ color: theme.textDisabledColor }),
                )}
            >
                {children}
            </div>
        </div>
    );
}
